import { mergeClassName as e } from "../../utils/data.js";
import { normalizeColorName as t } from "../../utils/colors.js";
import n from "./Banner.module.js";
import { Typography as r } from "../Typography/Typography.js";
import { jsx as i } from "react/jsx-runtime";
//#region lib/components/Banner/Banner.tsx
function a({ backgroundColor: a = "neutral", className: o, style: s, children: c, ...l }) {
	return /* @__PURE__ */ i("section", {
		...l,
		style: {
			backgroundColor: `var(--ag-${t(a)}-11)`,
			...s
		},
		className: e(n.banner, o),
		children: typeof c == "string" ? /* @__PURE__ */ i(r, { children: c }) : c
	});
}
//#endregion
export { a as Banner };
